import React, { useState } from 'react';

interface ShareButtonsProps {
    title: string;
}

const CopyIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
);
const TwitterIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path></svg>
);
const FacebookIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>
);
const LinkedInIcon: React.FC<{className?: string}> = ({className}) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle></svg>
);


const ShareButtons: React.FC<ShareButtonsProps> = ({ title }) => {
    const [copied, setCopied] = useState(false);
    const url = window.location.href;
    const text = `Check out this project: ${title}`;

    const handleCopy = () => {
        navigator.clipboard.writeText(url).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    const shareLinks = {
        twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
        linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`,
    };

    return (
        <div className="flex items-center space-x-4 flex-wrap gap-y-2">
            <span className="text-sm font-semibold text-gray-600">Share:</span>
            <button onClick={handleCopy} title="Copy Link" className="text-gray-500 hover:text-brand-dark transition-colors">
                <CopyIcon className="w-5 h-5"/>
            </button>
            <a href={shareLinks.twitter} target="_blank" rel="noopener noreferrer" title="Share on Twitter" className="text-gray-500 hover:text-brand-dark transition-colors">
                <TwitterIcon className="w-5 h-5"/>
            </a>
            <a href={shareLinks.facebook} target="_blank" rel="noopener noreferrer" title="Share on Facebook" className="text-gray-500 hover:text-brand-dark transition-colors">
                <FacebookIcon className="w-5 h-5"/>
            </a>
            <a href={shareLinks.linkedin} target="_blank" rel="noopener noreferrer" title="Share on LinkedIn" className="text-gray-500 hover:text-brand-dark transition-colors">
                <LinkedInIcon className="w-5 h-5"/>
            </a>
            {copied && <span className="text-sm text-green-600">Copied!</span>}
        </div>
    );
};

export default ShareButtons;